angular.module('bmsApp.settings').controller('MMPayMethodCtrl', [
	'$scope',
	'$log',
	'AppSettingsSvc',
	'notify',
	function ($scope, $log, AppSettingsSvc, notify) {

		$scope.settingData = {};
		$scope.loaded = false;

		AppSettingsSvc.index()
				.then(function (response) {
					$scope.settingData = response.data.settings;
					$scope.loaded = true;
				}, function (error) {
					$scope.errors = error;
				});

		$scope.submit = function (settingData) {
			var promise;
			promise = AppSettingsSvc.update(settingData);

			promise.then(function (response) {
				notify({
					message: 'Settings saved'
				});
			}, function (error) {
				$scope.errors = error;
			});

		}

	}]);



